import type { SYSTableDefIds } from "../../../../../../../_ovlclient/src"
import { html } from "../../../../../../../_ovlclient/src"
import { FileGet } from "../../../../../../../_ovlclient/src/global/globalapi"
import { DialogOpen } from "../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import { FormInit } from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { SYSBaseElement } from "../../../../../../../_ovlclient/src/library/sysbaseelement"
import {
  TableFormEditRow,
  TableGet,
} from "../../../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../../../_ovlclient/src/textapi"
import { GetCadAttribute } from "../../../features/qutoffering/offeringsettings/helpers"
import { BrowseOfferFile, EditLocked, SelectOfferFile } from "./helpers"

export class ScreenOffering extends SYSBaseElement {
  browseFileEl: HTMLInputElement
  offeringToolState: typeof this.state.app.features.QUTOffering
  async init() {
    this.offeringToolState = this.state.app.features.QUTOffering
    await super.init()
  }
  async afterRender() {
    this.browseFileEl = <HTMLInputElement>(
      document.getElementById("offering-newfile")
    )
  }

  async handleDocClick(e: Event) {
    e.preventDefault()
    e.stopPropagation()
    await FileGet({
      cat: "OfferingToolDocPDF",
      id1: this.offeringToolState.offerMainType,
    })
  }

  async getUI() {
    const handleEdit = (e) => {
      e.preventDefault()
      TableFormEditRow(
        "QUTOfferingSettings",
        Object.keys(
          this.state.app.global.QUT.tables.QUTOfferingSettings.data
        )[0]
      )
    }

    let uploadDisabled = EditLocked()

    let isCAD = this.offeringToolState.offerMainType === "CAD"

    let add
    if (isCAD) {
      add = html`
        <div class="uploaderandwarning">
          <div class="fd-file-uploader offering-uploader">
            <button
              ?disabled=${uploadDisabled}
              @click=${() => BrowseOfferFile()}
              id="asset_browse_button1"
              class="fd-button"
              aria-label="file auswählen"
            >
              <span class="fd-button__text"
                >${T("QUTOfferingOfferingNewOffer")}</span
              >
              <i class="sap-icon--upload"></i>
            </button>
          </div>
          <div
            class="fd-file-uploader__hidden"
            aria-live="polite"
            aria-atomic="true"
          ></div>
          <input
            id="offering-newfile"
            class="fd-file-uploader__hidden"
            @input=${async (e) => {
              this.state.app.features.QUTOffering.adminResumeDocEntry =
                undefined
              await SelectOfferFile(e.target.files[0], undefined)
            }}
            type="file"
          />
          <div class="fd-message-strip fd-message-strip--warning __warninghint">
            <p class="fd-message-strip__text">
              ${T("QUTOfferingCadVersionWarningHint")}
            </p>
          </div>
        </div>
      `
    } else {
      add = html`<div>
        <button
          ?disabled=${uploadDisabled}
          @click=${async () => {
            // if opened from here its always a new table
            // still we need to contact server for the schema
            let tb = TableGet("QUTOfferingPos")
            await tb.refresh({
              localData: [],
              forcedFilters: { staticFilter: { U_DocEntry: -1 } },
              resetStrategy: { ClearData: true },
            })
            await FormInit(
              "SYSEdit",
              {
                SYSEdit_Commission: {
                  type: "text",
                  schema: { nullable: false },
                  ui: { labelTranslationKey: "GENCommission" },
                },
              },
              { feature: "QUTOfferingPos", formId: "QUTOfferingPos" }
            )
            this.state.app.features.QUTOffering.cutListDirty = false
            this.state.app.features.QUTOffering.cutFileName = ""
            DialogOpen("QUTOfferingPos")
          }}
          id="cut_add"
          class="fd-button"
        >
          <span class="fd-button__text"
            >${T("QUTOfferingOfferingNewOffer")}</span
          >
          <i class="sap-icon--add"></i>
        </button>
      </div>`
    }
    let manual = html` <div>
      <a
        href="#"
        class="fd-link"
        tabindex="0"
        @click=${(e) => this.handleDocClick(e)}
      >
        <span class="sap-icon--pdf-attachment sap-icon--xl"></span>
        ${T("QUTOfferingOfferingManual")}
      </a>
    </div>`

    let instantOffer
    let userSettings
    let howToVideo
    let offeringOverview
    if (isCAD) {
      instantOffer = html`
        <div>
          <a
            href="mailto:instant-offer@kaltag.ch"
            target="_blank"
            class="fd-link"
            tabindex="0"
          >
            <span class="sap-icon--email sap-icon--xl"></span>
            ${T("QUTOfferingOfferingInstantMail")}
          </a>
        </div>
      `

      userSettings = this.state.app.global.GEN.user

      howToVideo = html`
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/iyF_B9d9l1Q"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      `
      offeringOverview = html`
        <div class="offering-overview">
          ${howToVideo}
          <div class="offering-links-settings">
            ${manual} ${instantOffer}
            <div class="offering-cadattrib">
              <a @click=${handleEdit} href="#" class="fd-link " tabindex="0">
                <span class="sap-icon--settings sap-icon--xl"></span>
                ${T("QUTOfferingOfferingCadHint", [
                  GetCadAttribute(),
                  userSettings.offeringCadVal,
                ])}
              </a>
            </div>
          </div>
        </div>
      `
    }
    let title
    let actions
    if (isCAD) {
      title = T("QUTOfferingOffering")
    } else {
      title = T("QUTOfferingOfferingCut")
      actions = html`<div class="fd-layout-panel__actions">${manual}</div>`
    }

    return html`
      <div class="ovl-smart-padding-lr-symmetrical ovl-smart-screen-margins">
        <div class="fd-layout-panel ">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">${title}</h3>
            </div>
            ${actions}
          </div>

          <div class="fd-layout-panel__body">
            ${offeringOverview} ${add}

            <ovl-table
              class="fd-table offering-table"
              .props=${() => <SYSTableDefIds>"QUTOffering"}
            >
            </ovl-table>
          </div>
        </div>
      </div>
    `
  }
}
